import { Config } from "./config";

const CoyResource = {
    base: "/api/coy",
    info(callback) {
        Config.Connection()
            .get(`${this.base}/info`)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    setup(data, callback) {
        Config.Connection()
            .post(`${this.base}/setup`, data)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    activeFeatures(callback) {
        Config.Connection()
            .get(`${this.base}/active-features`)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    features(data, callback) {
        Config.Connection()
            .get(`${this.base}/features`, { params: data })
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    syncFeature(callback) {
        Config.Connection()
            .get(`${this.base}/sync-feature`)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    get(id, callback) {
        Config.Connection()
            .get(`${this.base}/${id}`)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    list(criteria, callback) {
        Config.Connection()
            .get(this.base, { params: criteria })
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    create(data, callback) {
        Config.Connection()
            .post(this.base, data)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    update(data, callback) {
        Config.Connection()
            .put(this.base, data)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
};

export default CoyResource;